<script lang="ts">
    import { Col,Accordion, AccordionItem  } from "sveltestrap";
    import {  AccordionWithIcon, AccordionWithIconMessage, CollapsibleGroupItem, GroupItem} from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
</script>
<Col sm="12" lg="6">
    <Card cardProps="accordion-with-icon default-according" cardHeader2props="pb-0" >
      <div slot="customHeader2">
        <h5>{AccordionWithIcon}</h5>
        <span>{@html AccordionWithIconMessage}</span>
      </div>
      <div slot="contentbody">
        <Accordion>
          <AccordionItem active>
            <h5 class="m-0 " slot="header">
              <i class="icofont icofont-briefcase-alt-2"></i>{CollapsibleGroupItem}<span>1</span></h5> 
              {GroupItem}
          </AccordionItem>
          <AccordionItem>
            <h5 class="m-0 " slot="header">
              <i class="icofont icofont-support"></i>{CollapsibleGroupItem}<span>2</span></h5>
              {GroupItem}
          </AccordionItem>
          <AccordionItem>
            <h5 class="m-0 " slot="header">
              <i class="icofont icofont-tasks-alt"></i>{CollapsibleGroupItem}<span>3</span></h5>
              {GroupItem}
          </AccordionItem>
        </Accordion>
      </div>
    </Card>
</Col>